<template>
  <c-view>
    <c-page>
      <c-navbar title="邀请有礼">
      </c-navbar>
      <c-content>
        <div class="main">
          <div class="btn-box"><a href="javascript:;" @click="handlerInvite">分享资料邀请</a></div>
          <div class="result__box">
            <div class="result__cover">
              <p class="money__box">
                <span class="money__icon">￥</span>
                <span class="money">{{dataObj.amount|currencyNormal}}</span></p>
              <p>已获得奖金</p>
            </div>
            <div class="result__title g-container">
              <img src="../../assets/images/invite/title-left.png" alt="">
              我的邀请记录
              <img src="../../assets/images/invite/title-right.png" alt="">
            </div>
            <div class="list__box">
              <ul class="list g-container">
                <li v-for="(item, index) in dataObj.items" :key="item + index" class="list__item">
                  <span class="list__span list__time">
                    <span>{{item.rewardTime | onlyDate}}</span>
                    <span class="time--only list__span list__tips">{{item.rewardTime | onlyTime}}</span>
                  </span>
                  <span class="list__span list__name">
                    {{item.rewardName}}
                     <span class="list__span list__tips">
                       {{computedStatus(item)}}
                     </span>
                  </span>
                  <span class="list__span list__money"><span class="list__money__icon">￥</span>{{item.amount}}元</span>
                </li>
                <div v-if="dataObj.items.length === 0" class="no-data">
                  <p>有奖不拿太可惜了</p>
                  <p>快来邀请朋友参与吧</p>
                </div>
              </ul>
            </div>
          </div>
          <div class="result__title g-container rule__box">
            <a href="javascript:;" @click="handlerProvision">
              <img src="../../assets/images/invite-newversion/rule-left.png" alt="" class="rule__leftimg">
              邀请规则
              <img src="../../assets/images/invite-newversion/rule-right.png" alt="" class="rule__rightimg">
              </a>
            </div>  
        </div>
      </c-content>
    </c-page>
    <!--弹窗-->
    <transition name="fade">
      <div class="dialog" v-show="dialogVisible">
        <div class="weui-mask"></div>
        <div class="dialog__box">
          <div class="dialog__title">
            <h2>请绑定您的微信</h2>
            <span>用于公众号发送现金红包</span>
          </div>
          <div class="dialog__introduction">
            <span>
              第一步：微信搜索【生意专家商户助手】公众号
            </span>
            <span>
              第二步：点击【绑定账号】获得绑定验证码
              </span>
            <span>
              第三步：回到本页面输入验证码
            </span>
          </div>
          <div class="dialog__main">
            <div>
              <input type="text"
                     ref="J_Code"
                     @blur="resetScroll"
                     v-model="code"
                     class="code__input"
                     placeholder="请输入【微信验证码】"/>
              <span class="code__btn btn" @click="wakewechat">
              打开微信
               <i v-if="bindLoading" class="weui-loading"></i>
            </span>
            <span class="code__bind" 
            :class="{'weui-btn_loading': bindLoading}"
            @click="handlerBind">完成绑定</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--分享-->
    <share :visible.sync="share.shareVisible" :config="share.config"></share>
  </c-view>
</template>

<script>
  import Invite from '../../model/invite/index'
  import debounce from 'lodash.debounce'
  import Share from './share'
  // import Clipboard from 'clipboard'
  export default {
    name: 'Invite',
    components: { Share },
    data () {
      return {
        inviteModel: new Invite(),
        code: '',
        dialogVisible: false,
        share: {
          shareVisible: false,
          config: {}
        },
        dataObj: {
          amount: 0,
          items: []
        },
        shareLink: null,
        bindResult: null,
        inviteLoading: false,
        bindLoading: false
      }
    },
    mounted () {
      // 设置title
      if (window.$fe_bridge && window.$fe_bridge.about.device.iOS) {
        window.$fe_bridge.navigation.setTitle('邀请有礼')
        // window.$fe_bridge.navigation.setRightButton('normal', '条款', 'windowGoProvision();')
      }
      this._getMoneyList()
    },
    // 界面销毁时的事件
    destroyed () {
      if (window.$fe_bridge && window.$fe_bridge.about.device.iOS) {
        window.$fe_bridge.navigation.removeRightButton() // 除去IOS右侧按钮
      }
    },
    methods: { // 唤起微信
      wakewechat () {
        window.$fe_bridge.wake.wechat()
      },
      /**
       * 立即邀请弹窗
       */
      handlerInvite: debounce(async function () {
        if (this.bindResult === null) {
          if (this.inviteLoading) return
          this.inviteLoading = true
          let loadingInstance = this.$wejs.loading('获取数据中')
          try {
            let result = await this.inviteModel.getUserBindStatus()
            loadingInstance.hide()
            this.inviteLoading = false
            this.bindResult = result.data
          } catch (e) {
            loadingInstance.hide()
            this.inviteLoading = false
          }
        }
        if (!this.bindResult) { // 未绑定，弹窗进行绑定
          this.dialogVisible = true
        } else { // 已经绑定的用户进行分享
          this._shareDialog()
        }
      }, 300),
      /**
       * 绑定按钮
       */
      handlerBind: debounce(async function () {
        if (!this.code) {
          this.$wejs.alert('请输入微信验证码', () => {
            this.$refs.J_Code.focus()
          })
        } else if (this.code.length !== 6) {
          this.$wejs.alert('请输入正确的验证码', () => {
            this.$refs.J_Code.select()
          })
        } else {
          if (this.bindLoading) return // 正在绑定中进行返回
          this.bindLoading = true
          let result = await this.inviteModel.bindAccount(this.code)
          this.bindLoading = false
          if (result.data === true) { // 这里其它的会返回其它信息
            this.dialogVisible = false
            this._shareDialog()
          } else {
            this.$wejs.alert('绑定失败')
          }
        }
      }, 300),
      /**
       * 获取奖励列表
       * @private
       */
      _getMoneyList () {
        this.inviteModel.getMoneyList().then(data => {
          this.dataObj = data
        })
      },
      async _shareDialog () {
        if (!this.shareLink) {
          let loadingInstance = this.$wejs.loading('获取数据中')
          let result = await this.inviteModel.getShareInfo()
          this.share.config = {
            title: result.title,
            link: result.targetUrl,
            imgUrl: result.thumbUrl,
            description: result.summary
          }
          this.shareLink = result.targetUrl
          loadingInstance.hide()
          this.share.shareVisible = true
          this.bindResult = true
        } else {
          this.bindResult = true
          this.share.shareVisible = true
        }
      },
      /**
       * 导航部分条款，通过桥通知安卓事件
       */
      handlerProvision () {
        // if (window.$fe_bridge && window.$fe_bridge.about.device.android) {
        //   window.$fe_bridge.page.provisionPage()
        // }
        this.$router.push('/provision')
      },
      // ios 兼容，input失去焦点后界面上移不恢复的问题
      resetScroll () {
        setTimeout(() => {
          let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        }, 100)
      },
      /**
       * 获取领取状态
       * @param item
       */
      computedStatus (item) {
        if (item.rewardType === 1) { // 注册奖励
          if (item.state === 0) {
            return '待发放'
          } else if (item.state === 1) {
            return '已发放'
          } else if (item.state === 2) {
            return '异常注册'
          } else {
            return '待发放'
          }
        } else if (item.rewardType === 2) { // 消费奖励
          if (item.state === 0) {
            return '待发放'
          } else if (item.state === 1) {
            return '已发放'
          } else if (item.state === 2) {
            return '订单已退款'
          } else {
            return '待发放'
          }
        }
      }
    },
    watch: {
      dialogVisible (val) {
        if (val) {
          this.$nextTick(() => {
            if (window.$fe_bridge.about.device.android) {
              this.$refs.J_Code.focus()
            }
          })
        } else {
          this.code = ''
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "./index";
</style>



// WEBPACK FOOTER //
// index.vue?7296f5f6